import React, { Component } from 'react'
import { connect } from 'react-redux'
import AppHeader from './AppHeader'
import Metar from './Metar'
import LoadingSplash from './LoadingSplash'
import TextLookup from './TextLookup'
import LocationLookup from './LocationLookup'
import * as action from '../actions/actions'
import classnames from 'classnames'
import queryString from 'query-string'
import './styles/MetarList.css'

class MetarList extends Component {

  componentWillMount() {
    this.syncLatLongQueryToProps()
  }

  componentWillReceiveProps(nextProps) {
    this.pushLocationToHistory(nextProps)
  }

  render() {
    const coordinates = this.props.latitude && this.props.longitude ?
      this.props.latitude.toFixed(4) + ', ' + this.props.longitude.toFixed(4) :
      null
    if(this.props.metars.length === 0 && !this.props.isFetching) {
      return (
        <div className={
          classnames('metarList', 'darkBackground')
        }>
          <AppHeader />
          <LoadingSplash
            isFetching={true}
            title="Welcome to METAR4u"
            message="Search for a location to find METARs."
          >
          </LoadingSplash>
          <div className={"metarListFooter"}>
            <LocationLookup
              onClick={this.props.updateGeoAndMetarLocation}
            />
            <TextLookup
              onSubmit={this.props.updateMetarLocation}
              placeholder={"Location..."}
            />
          </div>
        </div>
      )
    } else {
      return (
        <div className={
          classnames('metarList', {
            lightBackground: this.props.isFetching,
            darkBackground: !this.props.isFetching
          })
        }>
          <AppHeader />
          <LoadingSplash
            isFetching={this.props.isFetching}
            title="Looking for your location..."
            message="Looking for your location..."
          >
            <div className="location">
              <div className="locationName">
                {this.props.locationName ? this.props.locationName : null}
              </div>
              <div className="locationCoordinates">
                {coordinates}
              </div>
            </div>
            <div className="list">
              {this.props.metars.map((metar, index) => {
                return (
                  <Metar
                    key={metar.icao + this.props.updatedAt}
                    icao={metar.icao}
                    metar={metar}
                  />
                )
              })}
            </div>
          </LoadingSplash>
          <div className={"metarListFooter"}>
            <LocationLookup
              onClick={this.props.updateGeoAndMetarLocation}
            />
            <TextLookup
              onSubmit={this.props.updateMetarLocation}
              placeholder={"Location..."}
            />
          </div>
        </div>
      )
    }
  }

  syncLatLongQueryToProps() {
    const _isNumeric = n => {
      return !isNaN(parseFloat(n)) && isFinite(n)
    }
    if(this.props.location.search) {
      var qString = queryString.parse(this.props.location.search)
      if(qString && qString.latitude && qString.longitude &&
        _isNumeric(qString.latitude) && _isNumeric(qString.longitude) &&
        (Number(qString.latitude) !== this.props.latitude || Number(qString.longitude) !== this.props.longitude)) {
        this.props.updateMetarLocationLatLong(Number(qString.latitude), Number(qString.longitude))
      }
    }
  }

  pushLocationToHistory(nextProps) {
    if(this.props.latitude !== nextProps.latitude ||
      this.props.longitude !== nextProps.longitude) {
        let qString = {}
        if(this.props.location.search) {
          qString = queryString.parse(this.props.location.search)
        }
        qString.latitude = nextProps.latitude
        qString.longitude = nextProps.longitude
        this.props.history.push("?" + queryString.stringify(qString))
    }
  }
}

const scrollAndUpdateMetarLocation = (dispatch, input) => {
  setTimeout(() => window.scrollTo(0, 0), 0)
  dispatch(action.searchAndUpdateMetarLocation(input))
}

const mapStateToProps = state => {
  return {
    isFetching: state.geolocation.isFetching,
    locationName: state.metarLocation.name,
    latitude: state.metarLocation.lat,
    longitude: state.metarLocation.long,
    metars: state.metarLocation.metars,
    updatedAt: state.metarLocation.updatedAt
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateGeoAndMetarLocation: () => dispatch(action.updateGeoAndMetarLocation()),
    updateMetarLocation: input => scrollAndUpdateMetarLocation(dispatch, input),
    updateMetarLocationLatLong: (lat, long) => dispatch(action.updateMetarLocation(lat, long))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MetarList)



// WEBPACK FOOTER //
// ./src/components/MetarList.js